export default "__VITE_ASSET__21f79463__"